import echarts from 'echarts';
import { config } from '@/views/home/chartJs/chartCommon';

export default function drawBar(params) {
  let { fontColor, fontSize, barMColor, tooltip, legend, xAxis } = config;
  // let dimensions = [];
  // for (let i in params.data[0]) {
  //   dimensions.push(i);
  // }

  let option = {
    dataset: {
      dimensions: ['city', 'funds', 'porportion'],
      source: params.data,
    },
    // backgroundColor: '#091C3D',
    tooltip,
    legend: {
      ...legend,
      ...params?.legend,
    },
    grid: {
      left: 10,
      top: params.grid ? params.grid.top : '20%',
      right: 20,
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        ...config.xAxis[0],
        axisLabel: {
          color: fontColor,
          textStyle: {
            fontSize,
          },
          interval: 'auto',
        },
      },
    ],
    yAxis: [
      {
        ...config.yAxis[0],
        name: params.yAxis.names[0],
      },
      {
        ...config.yAxis[0],
        name: params.yAxis.names[1],
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        type: 'bar',
        name: params.names[0],
        barWidth: 4,
        // barGap: 0,//柱间距离
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: barMColor[0],
              },
              {
                offset: 1,
                color: 'rgba(0, 120, 255, 0)',
              },
            ]),
            borderRadius: 2,
          },
        },
      },
      {
        type: 'line',
        name: params.names[1],
        yAxisIndex: 1,
        // symbol: 'none',
        symbolSize: 1,
        label: {
          show: true,
          position: 'top',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
        },
        itemStyle: {
          color: barMColor[2],
        },
      },
    ],
  };
  return option;
}
